const generatePdfLayout = (data, customerCopy = false) => {
  const pageHeight = 100;
  const pages = [];
  let currentPage = [];
  let currentPageHeight = 0;

  const inspectionSheet = data?.inspectionSheet || {};
  const baseSheetForHeader = data?.baseSheet || inspectionSheet;
  const bays = Array.isArray(data?.bays) ? data.bays : [];
  const techs = Array.isArray(data?.techs) ? data.techs : [];

  const componentSizes = {
    pdfHeader: (isFirstPage) => (isFirstPage ? 23 : 15),
    SystemInfoSection: 30,
    BaySection: (bay) => {
      if (!bay) {
        return 0;
      }
      let size = 32;
      const deltaArray = Array.isArray(bay.deltaT) ? bay.deltaT : [];
      size += deltaArray.length * 1.5;
      if (typeof bay.notes === 'string' && bay.notes.trim().length > 0) {
        size += Math.max(5, Math.ceil(bay.notes.trim().length * 0.02));
      }
      return size;
    },
    FinalCheckSection: (notes) => {
      const text = typeof notes === 'string' ? notes.trim() : '';
      if (!text) {
        return 6;
      }
      const additionalSize = Math.max(5, Math.ceil(text.length * 0.03));
      return 6 + additionalSize;
    },
    TechnicianSection: (technicians) => {
      if (!Array.isArray(technicians) || technicians.length === 0) {
        return 0;
      }
      return technicians.length * 5;
    },
  };

  const addHeader = (isFirstPage) => {
    const headerSize = componentSizes.pdfHeader(isFirstPage);
    currentPage.push({ type: 'pdfHeader', data: baseSheetForHeader });
    currentPageHeight += headerSize;
  };

  const finalizePage = () => {
    if (currentPage.length > 0) {
      pages.push(currentPage);
      currentPage = [];
      currentPageHeight = 0;
    }
  };

  const addComponent = (component, size) => {
    if (size <= 0) {
      return;
    }
    if (currentPageHeight + size > pageHeight) {
      finalizePage();
      addHeader(false);
    }
    currentPage.push(component);
    currentPageHeight += size;
  };

  // Start with the first page
  addHeader(true);

  // SystemInfoSection
  addComponent({ type: 'SystemInfoSection', data: inspectionSheet }, componentSizes.SystemInfoSection);

  // BaySections (pair two bays per row)
  for (let i = 0; i < bays.length; i += 2) {
    const bayPair = bays.slice(i, i + 2);
    const firstSize = componentSizes.BaySection(bayPair[0]);
    const secondSize = bayPair.length > 1 ? componentSizes.BaySection(bayPair[1]) : 0;
    const maxSize = Math.max(firstSize, secondSize);
    if (maxSize > 0) {
      addComponent({ type: 'BaySection', data: bayPair }, maxSize);
    }
  }

  // FinalCheckSection
  addComponent(
    { type: 'FinalCheckSection', data: {} },
    componentSizes.FinalCheckSection(inspectionSheet.visualInspectionNotes)
  );

  // TechnicianSection (only when not a customer-only copy and we have technicians)
  if (!customerCopy && techs.length > 0) {
    addComponent({ type: 'TechnicianSection', data: techs }, componentSizes.TechnicianSection(techs));
  }

  // Push any remaining components into the last page
  finalizePage();

  return pages;
};

export default generatePdfLayout;
